export default __webpack_public_path__ + "static/media/termsAndConditionsPlaceholder-milg31nitn13oi93-700x525-png.png.0dd97a75.png";